import React from 'react';
import './education.css';

const Education = () => {
  return (
    <div className="time-line">
      <div className="e-name">
        <span>My Education</span>
        <span>Details </span>
        <span>School / College </span>
      </div>

      <div className="container left-c">
        <img src="" alt="" />
        <div className="text-box">
          <h2>Saint Thomas school</h2>
          <h3>2000 - 2015</h3>
          <h3>(ICSE Board)</h3>
          <h3>Location: Khalilabad (Uttar Pradesh), India</h3>
          <span className="left-c-arrow"></span>
        </div>
      </div>

      <div className="container right-c">
        <img src="" alt="" />
        <div className="text-box">
          <h2>Saint Thomas Inter College</h2>
          <h3>2015 - 2017</h3>
          <h3>(ISC Board)</h3>
          <h3>Location: Khalilabad (Uttar Pradesh), India</h3>
          <span className="right-c-arrow"></span>
        </div>
      </div>

      <div className="container left-c">
        <img src="" alt="" />
        <div className="text-box">
          <h2>Mit - World Peace University</h2>
          <h3>2018 - 2022</h3>
          <h3>(Engineering)</h3>
          <h3>Location: Pune (Maharashtra), India</h3>
          <span className="left-c-arrow"></span>
        </div>
      </div>

      <div className="container right-c">
        <img src="" alt="" />
        <div className="text-box">
          <h2>Newton school</h2>
          <h3>2022 - 2023</h3>
          <h3>(Internship/Experience)</h3>
          <h3>Location: Bangalore (Tamil Nadu), India</h3>
          <span className="right-c-arrow"></span>
        </div>
      </div>

      <div className="container left-c">
        <img src="" alt="" />
        <div className="text-box">
          <h2>Focus Realm</h2>
          <h3>july - 2023</h3>
          <h3>web developer/design intern)</h3>
          <h3>Location: WFH</h3>
          <span className="left-c-arrow"></span>
        </div>
      </div>

      <div className="container right-c">
        <img src="" alt="" />
        <div className="text-box">
          <h2>Geneus Solutions</h2>
          <h3>jan - 2024</h3>
          <h3>(Internship/Experience)</h3>
          <h3>Location: WFH</h3>
          <span className="right-c-arrow"></span>
        </div>
      </div>

       <div className="container left-c">
        <img src="" alt="" />
        <div className="text-box">
          <h2>ATTPL (Ashoka Today Technology Pvt Ltd)</h2>
          <h3>feb - 2024</h3>
          <h3>(Internship/Experience)</h3>
          <h3>Location: WFH</h3>
          <span className="left-c-arrow"></span>
        </div>
      </div>

      {/* Blur Divs */}
      <div
        className="p-blur"
        style={{
          background: '#C5F5FF',
          top: '11rem',
          left: '11rem',
          width: '21rem',
          height: '11rem',
          // left: '2rem',
        }}
      ></div>
      <div
        className="p-blur"
        style={{
          background: 'var(--purple)',
          top: '29rem',
          left: '51rem',
          width: '21rem',
          height: '21rem',
       
        }}
      ></div>
      <div
        className="blur s-blur1"
        style={{ background: '#ABF11174', left: '41rem', top: '15rem' }}
      ></div>
    </div>
  );
};

export default Education;
